import React from "react";
import { approach } from "../data/content";

function Approach() {
  return (
    <section id="approach" className="section section-dark">
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="eyebrow eyebrow-light">How we deliver</p>
          <h2 className="section-title">A clear, governed delivery process</h2>
          <p className="section-lead">
            Every engagement follows the same four stages, with transparent milestones and a single point
            of contact from kickoff to support.
          </p>
        </div>
        <ol className="steps" data-reveal>
          {approach.map((a) => (
            <li className="step" key={a.step}>
              <span className="step-num">{a.step}</span>
              <h3>{a.title}</h3>
              <p>{a.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default Approach;
